import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { trackGenericAction } from "../../shared/analytics/dataLayer";
import { ANALYTICS_EVENT_TYPES } from "../../shared/constants/analytics";
import constants from "../../shared/constants/index";
import { useReducers } from "../../shared/hooks/useReducer";
import "./style.scss";

const { TELUS_TV_PLUS, REDUCER_TYPE } = constants;

const RedirectPIK = () => {
  const { t: translate } = useTranslation();
  const { featureToggles } = useReducers(REDUCER_TYPE.APP);
  const { isDynatraceTrackingEnabled } = featureToggles;
  const desc = translate("migration_browser_telustvplus").replace(/\n\n\n/g, "\n\n");

  const trackPikMigration = () => {
    trackGenericAction(
      ANALYTICS_EVENT_TYPES.EXIT_CLICK,
      {
        name: "pik_migration",
        URL: TELUS_TV_PLUS,
      },
      isDynatraceTrackingEnabled
    );
  };

  useEffect(() => {
    trackGenericAction(
      ANALYTICS_EVENT_TYPES.NOTIFICATION_IMPRESSIONS,
      { message: translate("pik_migration") },
      isDynatraceTrackingEnabled
    );
  }, [translate, isDynatraceTrackingEnabled]);

  return (
    <div className="container">
      <div className="form-wrapper">
        <div className="heading">{translate("pik_migration")}</div>
        <div className="description">
          {desc.split("<link>").map((item, index) => {
            if (index === 0) {
              return item;
            }
            return (
              <>
                <a href={TELUS_TV_PLUS} className="link" onClick={trackPikMigration}>
                  {translate("telustvplus_url")}
                </a>
                {item}
              </>
            );
          })}
        </div>
        <button
          onClick={() => {
            trackPikMigration();
            window.location.replace(TELUS_TV_PLUS);
          }}
        >
          {translate("migration_browser_goto_telustvplus")}
        </button>
      </div>
    </div>
  );
};
export default RedirectPIK;
